const toNumber = (value) => {
    if (value === '' || value === null || value === undefined) return null;
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
};

const toFixed2 = (value) => {
    const num = Number(value);
    if (!Number.isFinite(num)) return '';
    return (Math.round(num * 100) / 100).toFixed(2);
};

const computeIncl = (excl, rate) => {
    const amount = toNumber(excl);
    if (amount === null) return '';
    return toFixed2(amount * (1 + (Number(rate) || 0) / 100));
};

const computeExcl = (incl, rate) => {
    const amount = toNumber(incl);
    if (amount === null) return '';
    return toFixed2(amount / (1 + (Number(rate) || 0) / 100));
};

const calculateMargin = (cost, price) => {
    const costAmount = toNumber(cost);
    const priceAmount = toNumber(price);
    if (costAmount === null || priceAmount === null || priceAmount <= 0) return '0.00';
    return toFixed2(((priceAmount - costAmount) / priceAmount) * 100);
};

const calculateMarkup = (cost, price) => {
    const costAmount = toNumber(cost);
    const priceAmount = toNumber(price);
    if (costAmount === null || costAmount <= 0 || priceAmount === null) return '0.00';
    return toFixed2(((priceAmount - costAmount) / costAmount) * 100);
};

const pricingRatios = (costIncl, priceIncl) => ({
    margin_percent: calculateMargin(costIncl, priceIncl),
    markup_percent: calculateMarkup(costIncl, priceIncl)
});

const priceFromMargin = (costIncl, marginPercent) => {
    const costAmount = toNumber(costIncl);
    const margin = toNumber(marginPercent);
    if (costAmount === null || margin === null || margin >= 100) return '';
    return toFixed2(costAmount / (1 - margin / 100));
};

const priceFromMarkup = (costIncl, markupPercent) => {
    const costAmount = toNumber(costIncl);
    const markup = toNumber(markupPercent);
    if (costAmount === null || markup === null) return '';
    return toFixed2(costAmount * (1 + markup / 100));
};

const applyCostChange = (prev, field, value, rate) => {
    const costIncl = field === 'cost_excl' ? computeIncl(value, rate) : value;
    const costExcl = field === 'cost_incl' ? computeExcl(value, rate) : value;
    return {
        cost_incl: costIncl,
        cost_excl: costExcl,
        ...pricingRatios(costIncl, prev.price_incl)
    };
};

const applyPriceChange = (prev, field, value, rate) => {
    const priceIncl = field === 'price_excl' ? computeIncl(value, rate) : value;
    const priceExcl = field === 'price_incl' ? computeExcl(value, rate) : value;
    return {
        price_excl: priceExcl,
        price_incl: priceIncl,
        ...pricingRatios(prev.cost_incl, priceIncl)
    };
};

const applyMarginChange = (prev, value, rate) => {
    const priceIncl = priceFromMargin(prev.cost_incl, value);
    return {
        margin_percent: value,
        price_incl: priceIncl,
        price_excl: computeExcl(priceIncl, rate),
        markup_percent: calculateMarkup(prev.cost_incl, priceIncl)
    };
};

const applyMarkupChange = (prev, value, rate) => {
    const priceIncl = priceFromMarkup(prev.cost_incl, value);
    return {
        markup_percent: value,
        price_incl: priceIncl,
        price_excl: computeExcl(priceIncl, rate),
        margin_percent: calculateMargin(prev.cost_incl, priceIncl)
    };
};

const applyVatChange = (prev, rate) => {
    const costIncl = prev.cost_incl !== '' ? toFixed2(prev.cost_incl) : computeIncl(prev.cost_excl, rate);
    const priceIncl = prev.price_incl !== '' ? toFixed2(prev.price_incl) : computeIncl(prev.price_excl, rate);
    return {
        cost_excl: computeExcl(costIncl, rate),
        cost_incl: costIncl,
        price_excl: computeExcl(priceIncl, rate),
        price_incl: priceIncl,
        ...pricingRatios(costIncl, priceIncl)
    };
};

export {
    toFixed2,
    computeIncl,
    computeExcl,
    calculateMargin,
    calculateMarkup,
    applyCostChange,
    applyPriceChange,
    applyMarginChange,
    applyMarkupChange,
    applyVatChange
};
